export enum ClosedPeriodTreatment {
  NotCharged = "NotCharged",
  Reduced = "Reduced",
}
